import React from "react";
import { withDownloadSavedReport } from "./../../../shared/containers/containerDownloadSavedReport";
import getDates from "./../../../shared/services/date.service";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

import styles from "./savedReportItem.module.scss";
import { blue } from "@material-ui/core/colors";

const SavedReportItem = (props) => {
  const startDate = new Date(props.data.startDate);
  const endDate = new Date(props.data.endDate);
  const { units } = props.data;

  const downloadSavedReport = (data) => {
    const { onDownloadSavedReport } = props;

    onDownloadSavedReport(
      data.id,
      { title: "" /* data.reportType.title  */ },
      data.units.length > 1 ? null : data.units[0],
      { title: "xlsx" },
      { startDate: props.data.startDate, endDate: props.data.endDate }
    );
  };

  const interval = `${getDates.getDateFormat2(startDate)} ${getDates.getTimeFormat1(startDate)} - 
  ${getDates.getDateFormat2(endDate)} ${getDates.getTimeFormat1(endDate)}`;

  return (
    <div className={styles.reportSavedItem}>
      <div className={styles.reportSavedItemInner}>
        <div className={styles.reportDate}>{`${getDates.getDateFormat2(props.data.timeStamp)} ${getDates.getTimeFormat2(
          props.data.timeStamp
        )} `}</div>
        <span className={styles.reportType}>
          <div>
            <TooltipWrapper title={`Скачать ${props.data.reportType.title}`} position="top">
              <div
                className={styles.downloadButton}
                onClick={(e) => {
                  e.stopPropagation();
                  downloadSavedReport(props.data);
                }}
              >
                <SaveAltIcon fontSize={"small"} style={{ color: "#4da1ff" }} />
              </div>
            </TooltipWrapper>
          </div>

          <div style={{ marginLeft: "10px", fontWeight: "500" }}> {props.data.reportType.title}</div>

          <div className={styles["infoItem_datesInfo"]} style={{ marginLeft: "30px", fontWeight: "500" }}>
            {interval}
          </div>
        </span>

        <div className={styles.historyItemCarsList}>
          {units.map((unit) => {
            return (
              <div key={unit.id} className={styles["infoItem_carInfo"]}>
                {unit.title + ", " + unit.registerNumber}
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.closeWrapper}>{props.btnClose}</div>
    </div>
  );
};

export default withDownloadSavedReport(React.memo(SavedReportItem));
